import { apiRequest } from './client.js';

export interface JourneyEntry {
  readonly occurredAt: string;
  readonly stage: string;
  readonly action: string;
  readonly actorUserId: string | null;
  readonly actorName: string | null;
  readonly remark: string | null;
  readonly detail: string | null;
  readonly source: string;
}

export interface JobJourney {
  readonly jobRequestId: string;
  readonly entryCount: number;
  readonly stages: readonly string[];
  readonly entries: readonly JourneyEntry[];
}

export const getJobJourney = (jobRequestId: string, token?: string | null) =>
  apiRequest<JobJourney>(`/v1/job-journey/${encodeURIComponent(jobRequestId)}`, { token });
